import { Content, FilledLinkToWebField } from '@prismicio/client';

import {
  ITitleTextMultiColumnImageTitleText,
  IItem,
  TitleTextMultiColumnImageTitleProps,
} from './types';

export const mapTitleTextMultiColumnImageTitleText = ({
  prismicContent,
}: {
  prismicContent: TitleTextMultiColumnImageTitleProps['slice'];
}): ITitleTextMultiColumnImageTitleText => {
  const items: IItem[] = prismicContent.items.map(
    (item: Content.TitleTextMultiColumnImageTitleSliceDefaultItem) => {
      const {
        image: { url: image, alt },
      } = item;

      return {
        ...item,
        image: image as string,
        alt: alt as string,
      };
    },
  );

  const { button_label, internal_link, external_link } = prismicContent.primary;

  const titleTextMultiColumnImageTitleText: ITitleTextMultiColumnImageTitleText =
    {
      ...prismicContent.primary,
      buttonLabel: button_label as string,
      link: internal_link || (external_link as FilledLinkToWebField)!.url,
      items,
    };

  return titleTextMultiColumnImageTitleText;
};
